import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx } from "vue";
import { useAppAuth } from '@/features/Login360/app/composables';
import LoginForm from '@/features/Login360/components/app/AppLoginFlow.vue';
import Welcome360 from '@/features/Login360/components/app/AppWelcome.vue';
import { Screen } from '@/features/Login360/shared/types';
import { onMounted } from 'vue';
import { useMixpanelConfig } from '@/utilities/mixpanel';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AppLogin360',
    setup(__props) {
        const { currentScreen } = useAppAuth();
        onMounted(() => {
            useMixpanelConfig('view_migration360_seller');
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Transition, {
                mode: "out-in",
                name: "slide-right"
            }, {
                default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(currentScreen) === _unref(Screen).FORM ? LoginForm : Welcome360)))
                ]),
                _: 1
            }));
        };
    }
});
